import React from 'react';

function StudentPage() {
  return <div></div>;
}

export default StudentPage;
